module.exports = __webpack_public_path__ + "static/media/arrowUp.0a59002d.svg";